export function startPersonalCheckout(payment: any) {
    if (payment?.provider === 'stripe' && payment.url) {
        window.location.href = payment.url;
        return;
    }
    if (payment?.provider !== 'alat') return;
    const start = () => {
        const popup = (window as any).Alatpay?.setup({
            apiKey: payment.alatKey,
            businessId: payment.alatBid,
            email: payment.email,
            phone: payment.phone || '',
            firstName: payment.firstName || 'Parent',
            lastName: payment.lastName || 'RYD',
            metadata: payment.metadata,
            currency: payment.currency,
            amount: payment.amount,
            onTransaction: (response: any) => {
                const id = response?.data?.id || response?.data?.Id || response?.id || response?.Id || '';
                if (id) {
                    window.location.href = `https://api-pro.rydlearning.com/common/payment-status-wema?trxref=${encodeURIComponent(id)}`;
                }
            },
        });
        popup?.show?.();
    };
    if ((window as any).Alatpay) {
        start();
        return;
    }
    const script = document.createElement('script');
    script.src = 'https://web.alatpay.ng/js/alatpay.js';
    script.onload = start;
    document.body.appendChild(script);
}
